import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
    URL_EXTENSION
} from "../utility/config";

function Login() {

    const [userData, setUserData] = useState({
        email: '',
        password: ''
    })

    //Look at this closer
    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    const doSubmit = async (e) => {
        e.preventDefault()
        let token = null
        try {
            token = await axios.post(`${SERVER_URI}/admin_login/`, userData)
            window.localStorage.setItem("admin_token", (token.data.userToken))
            console.log("Token luotu")
            window.location.href = `${URL_EXTENSION}`
        } catch (e) {
            console.log("Error in login", e)
        }
    }
    return (
        <div className="login_card">
            <div>
                <h2 className="login_title">Kirjaudu sisään</h2>
                <form className="login_form" onSubmit={e => doSubmit(e)}>
                    <label htmlFor="phoneNumber">Sähköposti:</label>
                    <input type="email" id="email" name="email" placeholder="Sähköposti" onChange={onChange} required></input><br />

                    <label htmlFor="orderId">Salasana:</label>
                    <input type="password" id="password" name="password" placeholder="Salasana" onChange={onChange} required></input><br />
                    <input type="submit" id="gradient_Button" value="Kirjaudu sisään" />
                </form>
            </div>
        </div>

    );
}

export default Login;